import React, {Fragment} from 'react';
import {Button} from '../main/Styles/Toolbar.jsx';
import {CONNECTION_STATE} from './StateConstants.jsx';
import PropTypes from 'prop-types';

const NotConnectedStep = (props) => {
  NotConnectedStep.propTypes = {
    setState: PropTypes.func.isRequired
  };

  return (
    <Fragment>
      <div>
        <b>Error connecting to the scanner, or the firmware update failed.</b><p/>
        <b>Before contacting your customer support desk, please follow the steps below:</b><p/>
        <ol>
          <li>The USB cable should be connected between the scanner and computer.</li>
          <li>Make sure the scanner&apos;s power cable is firmly connected and the power switch is ON.</li>
          <li>The LED light should be GREEN.</li>
        </ol><p/>
        If the above steps do not resolve the issue, please contact your customer support desk.
      </div>
      <div>
        &nbsp;<p/>
        <Button variant="contained" color="primary"
          onClick={() => {
            props.setState(CONNECTION_STATE.CONNECTING);
          }}
        >
          Try again
        </Button>
      </div>
    </Fragment>
  );
};

export default NotConnectedStep;
